/**
 * Shake Animation Helper - Shared GSAP Animation System
 * Provides intersection observer-based animations for 310 Shake sections
 * Optimized to load GSAP once and reuse across multiple sections
 */

if (!window._shakeAnimationHelper) {
  window._shakeAnimationHelper = (function() {
    var registry = {};
    var observer = null;
    var designMode = window.Shopify && window.Shopify.designMode;
    var waiting = [];
    var loading = false;

    function ensureGsap(callback) {
      if (window.gsap) {
        callback();
        return;
      }
      waiting.push(callback);
      if (loading) return;
      loading = true;
      var script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/gsap.min.js';
      script.async = true;
      script.onload = function() {
        loading = false;
        var queue = waiting.splice(0);
        queue.forEach(function(fn) {
          try { fn(); } catch (err) { console.warn('Shake GSAP callback failed', err); }
        });
      };
      script.onerror = function() {
        loading = false;
        waiting = [];
        console.warn('Failed to load GSAP for Shake animations');
      };
      document.head.appendChild(script);
    }

    function initObserver() {
      if (observer || !('IntersectionObserver' in window)) return;
      observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting) return;
          var id = entry.target.getAttribute('id');
          var rec = registry[id];
          if (!rec) return;
          observer.unobserve(entry.target);
          play(rec, false);
        });
      }, { threshold: 0.25, rootMargin: '0px 0px -10% 0px' });
    }

    function applyPre(rec, force) {
      if (!rec.root) return;
      if (rec.prerendered && !force) return;
      rec.prerendered = true;
      if (rec.config.pre) rec.config.pre(rec.root);
    }

    function prepare(rec, force) {
      if (!rec.root) return;
      if (rec.prepared && !force) return;
      rec.prepared = true;
      if (rec.config.prepare && window.gsap) rec.config.prepare(window.gsap, rec.root);
    }

    function play(rec, force) {
      if (!rec.root) return;
      if (rec.animated && !force) return;
      ensureGsap(function() {
        applyPre(rec, force);
        prepare(rec, true);
        if (rec.config.animate) rec.config.animate(window.gsap, rec.root, force);
        rec.animated = true;
      });
    }

    function setup(rec) {
      rec.root = document.getElementById(rec.id);
      if (!rec.root) return false;
      applyPre(rec, true);
      if (designMode) {
        play(rec, true);
        return true;
      }
      if ('IntersectionObserver' in window) {
        ensureGsap(function() {
          prepare(rec, true);
          initObserver();
          observer.observe(rec.root);
        });
      } else {
        play(rec, false);
      }
      return true;
    }

    function register(config) {
      var rec = registry[config.id] = {
        id: config.id,
        sectionUid: config.sectionUid,
        config: config,
        root: null,
        prerendered: false,
        prepared: false,
        animated: false
      };

      var init = function() {
        if (!setup(rec)) {
          setTimeout(init, 120);
        }
      };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init, { once: true });
      } else {
        init();
      }
    }

    document.addEventListener('shopify:section:load', function(event) {
      var sectionUid = event && event.detail && event.detail.sectionId;
      if (!sectionUid) return;
      Object.keys(registry).forEach(function(key) {
        var rec = registry[key];
        if (rec.sectionUid === sectionUid) {
          rec.prerendered = false;
          rec.prepared = false;
          rec.animated = false;
          setup(rec);
        }
      });
    });

    document.addEventListener('shopify:section:select', function(event) {
      var sectionUid = event && event.detail && event.detail.sectionId;
      if (!sectionUid) return;
      Object.keys(registry).forEach(function(key) {
        var rec = registry[key];
        if (rec.sectionUid === sectionUid) {
          play(rec, true);
        }
      });
    });

    return {
      register: register,
      ensureGsap: ensureGsap
    };
  })();
}
